import { createContext, useEffect, useReducer } from "react";
import axios from "../utils/axios";
import ReportReducer from "../reducers/ReportReducer";
import { isValidToken, setSession } from "../utils/jwt";
import { ReportConstants } from "../constants/index";
import { saveFile } from "../utils/common";
const initialState = {
  isLoading: true,
  paymentGateways: [],
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  depositPaymentGateways: [],
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  dueReports: {
    dueReportSum: {
      discount: 0,
      serviceTax: 0,
      planAmount: 0,
      finalInvoiceAmount: 0,
    },
    paging: {
      totalNumberOfRecords: 0,
      totalNumberOfPages: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    data: [],
  },
  holdReports: {
    paging: {
      totalNumberOfRecords: 0,
      totalNumberOfPages: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    data: [],
  },
  comboReports: {
    comboReportSum: {
      serviceTaxAmount: 0,
      deductedLcoAmount: 0,
      lcoBalance: 0,
      deductedMsoAmount: 0,
      msoBalance: 0,
      msoShare: 0,
      msoShareAmount: 0,
      lcoShare: 0,
      lcoShareAmount: 0,
    },
    paging: {
      totalNumberOfRecords: 0,
      totalNumberOfPages: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    data: [],
  },
  renewalReports: {
    renewalReportSum: {
      planAmount: 0,
      serviceTaxAmount: 0,
      totalPayableAmount: 0,
    },
    paging: {
      totalNumberOfRecords: 0,
      totalNumberOfPages: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    data: [],
  },
  validityReports: {
    paging: {
      totalNumberOfRecords: 0,
      totalNumberOfPages: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    data: [],
  },
  collectionReports: {
    collectionReportSum: {
      discount: 0,
      serviceTax: 0,
      planAmount: 0,
      finalInvoiceAmount: 0,
    },
    paging: {
      totalNumberOfRecords: 0,
      totalNumberOfPages: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    data: [],
  },
  walletReports: {
    paging: {
      totalNumberOfRecords: 0,
      totalNumberOfPages: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    data: [],
  },
  sharingReports: {
    sharingReportSum: {
      renewalAmount: 0,
      msoShareAmount: 0,
      lcoShareAmount: 0,
      distShareAmount: 0,
      taxAmount: 0,
      ottRenewalAmount: 0,
      ottMsoShareAmount: 0,
      ottLcoShareAmount: 0,
      ottDistShareAmount: 0,
      ottTaxAmount: 0,
    },
    paging: {
      totalNumberOfRecords: 0,
      totalNumberOfPages: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    data: [],
  },
  updateDataLimitReports: {
    paging: {
      totalNumberOfRecords: 0,
      totalNumberOfPages: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    data: [],
  },
  staticIpReports: {
    paging: {
      totalNumberOfRecords: 0,
      totalNumberOfPages: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    data: [],
  },
  autoSearchLoading: false,
  isLoadingAutoSearch: true,
  downloadFileType: "",
  walletSumAmount: 0,
};
const initPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const ReportContext = createContext({
  ...initialState,
  downloadFile: () => {},
  getRenewalReports: () => {},
  getStaticIpReports: () => {},
  getUpdateDataLimitReports: () => {},
  getAllValidityReports: () => {},
  getDueReports: () => {},
  getHoldReports: () => {},
  getCollectionReports: () => {},
  getAllWallet: () => {},
  getSharingReports: () => {},
  downloadRenewalReport: () => {},
  getPaymentGatewayReport: () => {},
  getDepositPaymentGatewayReport: () => {},
  getComboReport: () => {},
  downloadHoldReport: () => {},
  downloadDuesReport: () => {},
  downloadWalletReport: () => {},
  downloadSharingReport: () => {},
  getWalletSumAmounts: () => {},
  downloadValidityReport: () => {},
  downloadStaticIpReport: () => {},
  downloadComboReport: () => {},
});

function ReportProvider({ children }) {
  const [state, dispatch] = useReducer(ReportReducer, initialState);

  const getRenewalReports = async (payload) => {
    try {
      dispatch({
        type: ReportConstants.FETCH_RENEWAL_REPORT_REQUEST,
      });
      const response = await axios.post("/radius/raduser/renew-reports", payload);

      dispatch({
        type: ReportConstants.FETCH_RENEWAL_REPORT_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: ReportConstants.FETCH_RENEWAL_REPORT_FAILURE,
      });
    }
  };

  const getUpdateDataLimitReports = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/renew-reports", payload);
      dispatch({
        type: ReportConstants.FETCH_UPDATE_DATA_LIMIT_REPORT_REQUEST,
      });
      dispatch({
        type: ReportConstants.FETCH_UPDATE_DATA_LIMIT_REPORT_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: ReportConstants.FETCH_UPDATE_DATA_LIMIT_REPORT_FAILURE,
      });
    }
  };

  const getStaticIpReports = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/static-ip-reports", payload);
      dispatch({
        type: ReportConstants.FETCH_STATIC_IP_REPORT_REQUEST,
      });
      dispatch({
        type: ReportConstants.FETCH_STATIC_IP_REPORT_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: ReportConstants.FETCH_STATIC_IP_REPORT_FAILURE,
      });
    }
  };

  const getAllValidityReports = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/validity-reports", payload);
      dispatch({
        type: ReportConstants.FETCH_VALIDITY_REPORT_REQUEST,
      });
      dispatch({
        type: ReportConstants.FETCH_VALIDITY_REPORT_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: ReportConstants.FETCH_VALIDITY_REPORT_FAILURE,
      });
    }
  };

  const getWalletSumAmounts = async (payload) => {
    try {
      dispatch({
        type: ReportConstants.FETCH_WALLET_SUM_REQUEST,
      });
      const response = await axios.post("/cpanel/wallet/sum-amount", payload);

      dispatch({
        type: ReportConstants.FETCH_WALLET_SUM_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: ReportConstants.FETCH_WALLET_SUM_FAILURE,
      });
    }
  };

  const getPaymentGatewayReport = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/renew-reports", payload);
      dispatch({
        type: ReportConstants.FETCH_PAYMENT_GATEWAY_REPORT_REQUEST,
      });
      dispatch({
        type: ReportConstants.FETCH_PAYMENT_GATEWAY_REPORT_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: ReportConstants.FETCH_PAYMENT_GATEWAY_REPORT_FAILURE,
      });
    }
  };

  const getDepositPaymentGatewayReport = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/renew-reports", payload);
      dispatch({
        type: ReportConstants.FETCH_DEPOSIT_PAYMENT_GATEWAY_REPORT_REQUEST,
      });
      dispatch({
        type: ReportConstants.FETCH_DEPOSIT_PAYMENT_GATEWAY_REPORT_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: ReportConstants.FETCH_DEPOSIT_PAYMENT_GATEWAY_REPORT_FAILURE,
      });
    }
  };

  const getComboReport = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/combo-reports", payload);
      dispatch({
        type: ReportConstants.FETCH_COMBO_REPORT_REQUEST,
      });
      dispatch({
        type: ReportConstants.FETCH_COMBO_REPORT_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: ReportConstants.FETCH_COMBO_REPORT_FAILURE,
      });
    }
  };

  const getDueReports = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/due-reports", payload);
      dispatch({
        type: ReportConstants.FETCH_DUE_REPORT_REQUEST,
      });
      dispatch({
        type: ReportConstants.FETCH_DUE_REPORT_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: ReportConstants.FETCH_DUE_REPORT_FAILURE,
      });
    }
  };
  const getHoldReports = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/hold-reports", payload);
      dispatch({
        type: ReportConstants.FETCH_HOLD_REPORT_REQUEST,
      });
      dispatch({
        type: ReportConstants.FETCH_HOLD_REPORT_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: ReportConstants.FETCH_HOLD_REPORT_FAILURE,
      });
    }
  };

  const getCollectionReports = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/collection-reports", payload);
      dispatch({
        type: ReportConstants.FETCH_COLLECTION_REPORT_REQUEST,
      });
      dispatch({
        type: ReportConstants.FETCH_COLLECTION_REPORT_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: ReportConstants.FETCH_COLLECTION_REPORT_FAILURE,
      });
    }
  };

  const downloadFile = async (fileType, payload) => {
    dispatch({
      type: ReportConstants.DOWNLOAD_USER_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post("/radius/raduser/export/" + fileType, payload, {
      responseType: "blob",
    });
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "user." + fileType);

    dispatch({
      type: ReportConstants.DOWNLOAD_USER_SUCCESS,
      payload: response.data,
    });
  };

  const downloadValidityReport = async (fileType, payload) => {
    dispatch({
      type: ReportConstants.DOWNLOAD_VALIDITY_REPORT_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post(
      "/radius/raduser/validity-reports/export/" + fileType,
      payload,
      {
        responseType: "blob",
      },
    );

    await saveFile(response.data, "Validity Report." + fileType);

    dispatch({
      type: ReportConstants.DOWNLOAD_VALIDITY_REPORT_SUCCESS,
      payload: response.data,
    });
  };

  const downloadStaticIpReport = async (fileType, payload) => {
    dispatch({
      type: ReportConstants.DOWNLOAD_STATIC_IP_REPORT_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    try {
      const response = await axios.post(
        "/radius/raduser/static-ip-reports/export/" + fileType,
        payload,
        {
          responseType: "blob",
        },
      );

      // Check if the server returned an error as a blob (JSON error response)
      const contentType = response.headers["content-type"] || "";
      if (contentType.includes("application/json")) {
        const text = await response.data.text();
        const errorData = JSON.parse(text);
        throw new Error(errorData.message || "Export failed");
      }

      await saveFile(response.data, "static_ip_report." + fileType);

      dispatch({
        type: ReportConstants.DOWNLOAD_STATIC_IP_REPORT_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.error("Static IP report export failed:", error);
      dispatch({
        type: ReportConstants.DOWNLOAD_STATIC_IP_REPORT_FAILURE,
      });
    }
  };

  const downloadRenewalReport = async (fileType, payload) => {
    dispatch({
      type: ReportConstants.DOWNLOAD_USER_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post("/radius/raduser/renewal/export/" + fileType, payload, {
      responseType: "blob",
    });
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "renewal_report." + fileType);

    dispatch({
      type: ReportConstants.DOWNLOAD_USER_SUCCESS,
      payload: response.data,
    });
  };
  const downloadComboReport = async (fileType, payload) => {
    dispatch({
      type: ReportConstants.DOWNLOAD_USER_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post("/radius/raduser/combo/export/" + fileType, payload, {
      responseType: "blob",
    });

    await saveFile(response.data, "combo_report." + fileType);

    dispatch({
      type: ReportConstants.DOWNLOAD_USER_SUCCESS,
      payload: response.data,
    });
  };

  const downloadDuesReport = async (fileType, payload) => {
    dispatch({
      type: ReportConstants.DOWNLOAD_USER_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post("/radius/raduser/dues/export/" + fileType, payload, {
      responseType: "blob",
    });
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "dues_report." + fileType);

    dispatch({
      type: ReportConstants.DOWNLOAD_USER_SUCCESS,
      payload: response.data,
    });
  };
  const downloadHoldReport = async (fileType, payload) => {
    dispatch({
      type: ReportConstants.DOWNLOAD_USER_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    try {
      const response = await axios.post(
        "/radius/raduser/hold-reports/export/" + fileType,
        payload,
        {
          responseType: "blob",
        },
      );

      // Check if the server returned an error as a blob (JSON error response)
      const contentType = response.headers["content-type"] || "";
      if (contentType.includes("application/json")) {
        // Read the blob as text to get the error message
        const text = await response.data.text();
        const errorData = JSON.parse(text);
        throw new Error(errorData.message || "Export failed");
      }

      await saveFile(response.data, "hold_report." + fileType);

      dispatch({
        type: ReportConstants.DOWNLOAD_USER_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.error("Hold report export failed:", error);
      dispatch({
        type: ReportConstants.DOWNLOAD_USER_FAILURE,
      });
    }
  };

  const downloadWalletReport = async (fileType, payload) => {
    dispatch({
      type: ReportConstants.DOWNLOAD_USER_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post("/cpanel/wallet/export/" + fileType, payload, {
      responseType: "blob",
    });
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "wallet_report." + fileType);

    dispatch({
      type: ReportConstants.DOWNLOAD_USER_SUCCESS,
      payload: response.data,
    });
  };

  const downloadSharingReport = async (fileType, payload) => {
    dispatch({
      type: ReportConstants.DOWNLOAD_USER_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post("/radius/raduser/sharing/export/" + fileType, payload, {
      responseType: "blob",
    });
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "sharing_report." + fileType);

    dispatch({
      type: ReportConstants.DOWNLOAD_USER_SUCCESS,
      payload: response.data,
    });
  };

  const getAllWallet = async (payload) => {
    try {
      const response = await axios.post("/cpanel/wallet/list", payload);
      dispatch({
        type: ReportConstants.FETCH_WALLET_REQUEST,
      });
      dispatch({
        type: ReportConstants.FETCH_WALLET_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: ReportConstants.FETCH_WALLET_FAILURE,
      });
    }
  };
  const getSharingReports = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/sharing-reports", payload);
      dispatch({
        type: ReportConstants.FETCH_SHARING_REPORT_REQUEST,
      });
      dispatch({
        type: ReportConstants.FETCH_SHARING_REPORT_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: ReportConstants.FETCH_SHARING_REPORT_FAILURE,
      });
    }
  };

  return (
    <ReportContext.Provider
      value={{
        ...state,
        downloadFile,
        getRenewalReports,
        getStaticIpReports,
        getUpdateDataLimitReports,
        getAllValidityReports,
        getDueReports,
        getHoldReports,
        getCollectionReports,
        getPaymentGatewayReport,
        getDepositPaymentGatewayReport,
        getComboReport,
        getAllWallet,
        getSharingReports,
        downloadRenewalReport,
        downloadDuesReport,
        downloadHoldReport,
        downloadWalletReport,
        downloadSharingReport,
        getWalletSumAmounts,
        downloadValidityReport,
        downloadStaticIpReport,
        downloadComboReport,
      }}
    >
      {children}
    </ReportContext.Provider>
  );
}

export { ReportContext, ReportProvider };
